import React, { useRef, useState } from 'react';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Head from 'next/head';
import { useRouter } from 'next/router';
import Header from '../../components/Header';
import Loader from '../../components/Loader/Loader';
import axios from 'axios';

const PortalLogin = () => {

  const emailRef = useRef();
  const router = useRouter();
  const [message, setMessage] = useState('');
  const [loader, setLoader] = useState(false);


  const handleClick = async (e) => {

    let validateInput = undefined;
    setLoader(true);

    if (!emailRef.current.value) {
      // if nothing is entered, just return
      return
    }

    try {
      validateInput =  await axios.get(`/api/s3/validate-email`, {
        params: {
          email: emailRef.current.value,
          task: 'encode',
        }
      });
    } catch(error) {
      console.log(error);
    }

    setLoader(false);

    if (validateInput.data === '') {
      setMessage("Sorry! Email not found");
    } else {
      router.push(`/portal/${validateInput.data}`);
    }
   
  }

  return (
    <>
      <Head>
        <title>Disc Golf Performance Lab</title>
        <meta name="description" content="Portal" />
        <link rel="icon" href="./black_icon_32.png" />
      </Head>
      <Header />
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', marginTop: '-50px' }}>
        <div style={{ textAlign: 'center' }}>
          <Card>
            <Card.Header as="h5">Login</Card.Header>
            <Card.Body>
              <Form>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  <Form.Label>Email address</Form.Label>
                  <Form.Control ref={emailRef} type="email" placeholder="name@example.com" onChange={() => {setMessage('')}}/>
                </Form.Group>
              </Form>
              <Button variant="secondary" onClick={handleClick}>Login</Button>
            </Card.Body>
          </Card> 
          {loader ? <Loader /> : ''}
          <div style={{color: 'red'}}>
            {message}
          </div>   
        </div>
      </div>
    </>
  )
}

export default PortalLogin;